import { IRootState } from "@/types/redux.type";
import { createSelector } from "reselect";

export const mainSelector = (state: IRootState) => state.auth;

export const userAuthorizedSelector = createSelector(mainSelector, (auth) => ({
  isAuthorized: auth?.isAuthorized,
  token: auth?.token
}));
